import { initContract } from "@ts-rest/core";
import { z } from "zod";

import {
  AddressSchema,
  CompanyMachineSchema,
  CompanySchema,
  CompanySettingsSchema,
  DefaultProcessStepSchema,
  MachineSchema,
  ModelSchema,
  OnboardingActivityTypeSchema,
  ProductSchema,
} from "../generated/prisma/zod";

const c = initContract();
export const companyContract = c.router({
  update: {
    method: "PATCH",
    path: "/company",
    responses: {
      200: CompanySchema.merge(
        z.object({
          address: AddressSchema,
          companyMachines: z.array(CompanyMachineSchema),
        }),
      ),
    },
    body: z.object({
      name: z.string().optional(),
      siret: z.string().optional(),
      iban: z.string().optional(),
      cgvUrl: z.string().optional(),
      logoUrl: z.string().optional(),
      onboardingActivityType: OnboardingActivityTypeSchema.optional(),
      address: z
        .object({
          street: z.string().optional(),
          city: z.string().optional(),
          zipCode: z.string().optional(),
        })
        .optional(),
    }),
    summary: "Update a company",
  },

  findMine: {
    method: "GET",
    path: "/company",
    responses: {
      200: CompanySchema.merge(
        z.object({
          address: AddressSchema,
          companyMachines: z.array(
            CompanyMachineSchema.merge(
              z.object({
                machine: MachineSchema,
              }),
            ),
          ),
          companySettings: CompanySettingsSchema.extend({
            model: ModelSchema.pick({ id: true, type: true }).nullable(),
            defaultProducts: z.array(ProductSchema),
            defaultProcessSteps: z.array(DefaultProcessStepSchema),
          }),
        }),
      ),
    },
    summary: "Find my company",
  },
  create: {
    method: "POST",
    path: "/company",
    responses: {
      201: CompanySchema,
    },
    body: z.object({
      name: z.string(),
      siret: z.string().optional(),
      iban: z.string().optional(),
      address: z
        .object({
          street: z.string(),
          city: z.string(),
          zipCode: z.string(),
        })
        .optional(),
    }),
    summary: "Create a company",
  },
  connect: {
    method: "POST",
    path: "/company/:id/connect",
    pathParams: z.object({ id: z.string().uuid() }),
    body: z.object({}).optional(),
    responses: {
      200: CompanySchema,
    },
    summary: "Connect user to a company",
  },
  completeSetup: {
    method: "POST",
    path: "/company/complete-setup",
    body: z.object({}).optional(),
    responses: {
      200: CompanySchema,
    },
    summary: "Mark the onboarding setup wizard as complete for the caller's company",
  },
  replayOnboarding: {
    method: "POST",
    path: "/company/replay-onboarding",
    body: z.object({}).optional(),
    responses: {
      200: CompanySchema,
    },
    summary: "Reset the onboarding exit date so the caller's company can replay the onboarding",
  },
});
